<ng-container *ngIf="true">
  <div class="cursor-pointer content-card" tabindex="0">
    <p class="cursor-pointer" style="margin: auto;" class="noselect" (click)="click($event)" (mousedown)="preventBlur()">
      <b>{{option}}</b>
    </p>
    <div class="mydropdown" #thedropdown [ngClass]="visible ? 'visible' : ''" (blur)="hide()" tabindex="1">
      <button *ngFor="let option of options" class="dropdown-item" type="button" (click)="onClick(option)" (mousedown)="preventBlur()">
        <b [style.color]="true ? '#000' : '#999'">{{option}}</b>
      </button>
      <hr>
    </div>
  </div>
</ng-container>
